import type { IMosaicTocExpanded, ITocActionUpdateTrafficLightsFilter } from "./interface";

/**
 * Updates the traffic-light filter used by the ToC.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the new traffic-light filter.
 * @returns The updated ToC state with the traffic-light filter applied.
 */
export const toc_updateTrafficLightsFilter = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateTrafficLightsFilter,
): IMosaicTocExpanded => ({
  ...state,
  trafficLightsFilter: action.trafficLightFilter,
});
